import React from 'react';
import PropTypes from 'prop-types';

import Item from './Item';

const ModulesTable = ({ access, enabledModules, disabledItems, onEdit }) => (
  <>
    {enabledModules?.length ? (
      <Item access={access} items={enabledModules} title="Active" type="edit" onEdit={onEdit} />
    ) : null}
    {disabledItems?.length ? <Item access={access} items={disabledItems} type="disabled" title="Other" onEdit={onEdit} /> : null}
  </>
);

ModulesTable.propTypes = {
  access: PropTypes.object,
  enabledModules: PropTypes.array,
  disabledItems: PropTypes.array,
  onEdit: PropTypes.func,
};

export default ModulesTable;
